import React from 'react';
import useSWR from 'swr';

import FinalistPhotoCard from './FinalistPhotoCard';

function FinalistPhotoGrid() {
    const { data: finalists } = useSWR('/public/poi-media/finalists', {
        revalidateIfStale: true,
        revalidateOnMount: true,
        dedupingInterval: 1000 * 60
    });
    return (
        <div className="finalist-photo-grid">
            {finalists?.data.map((poiMedia) => (
                <div
                    className={`photo-card ${
                        poiMedia.files.original.height > poiMedia.files.original.width ? 'portrait' : 'landscape'
                    }`}
                    key={poiMedia.id}
                >
                    <FinalistPhotoCard media={poiMedia} />
                </div>
            ))}
        </div>
    );
}

export default FinalistPhotoGrid;
